module.exports = __webpack_public_path__ + "img/depmap_svg_V14.c62e244f.svg";